/**
 系统管理--物料配置
 */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Modal, message } from "antd";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import fetchHandler from "@/fetch/fetchHandler";
import GoodExcelIn from "./goodExcelIn";
import { getMaterialsTypeList, updateMaterialsType, getMaterialsUseList, delMaterials } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { useAuth } from "@/utils/utils";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class TMaterialsTypeManage extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      seeStubBindLockVisible: false,
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
      adviceContent: null,
      adviceVisible: false,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getTypeList();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    const param = {
      date: `${moment(new Date()).subtract(0, "d").format("YYYY-MM-DD")},${moment(new Date())
        .subtract(0, "d")
        .format("YYYY-MM-DD")}`,
    };

    this.fetchApi(param);
  }

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
   */
  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  init() {
    this.setState({
      tableConfig: {
        tableKey: "tMaterialsTypeManageTable",
        tableColumns: [
          {
            name: "物料编号", // 7'物料编号',
            key: "materialsCode",
            colType: "textCol",
            align: "left",
          },
          {
            name: "物料名称", // '物料名称',
            key: "materialsName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "规格型号", // '规格型号',
            key: "regularModel",
            colType: "textCol",
            align: "left",
          },
          {
            name: "用途", // '用途',
            key: "useType",
            colType: "textCol",
            align: "left",
          },
          {
            name: "单位", // '个',
            key: "unit",
            colType: "textCol",
            align: "left",
          },
          {
            name: "新件价格(元)", // '新件价格',
            key: "newPrice",
            colType: "textCol",
            align: "left",
          },
          {
            name: "旧件价格(元)", // '旧件价格',
            key: "oldPrice",
            colType: "textCol",
            align: "left",
          },
          {
            name: "成本", // '成本',
            key: "cost",
            colType: "textCol",
            align: "left",
          },

          {
            name: "状态", // '状态',
            key: "status",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "启用";
              }
              return "禁用";
            },
          },
          {
            name: "品牌",
            key: "brand",
            colType: "textCol",
            align: "left",
          },
          {
            name: "处置方式",
            key: "handingType",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 2) {
                return "维修利用";
              } else if (text === 0) {
                return "其他";
              }
            },
          },

          {
            name: "备注", // '备注',
            key: "description",
            colType: "textCol",
            align: "left",
          },
          {
            name: "操作", // 操作
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              useAuth("901403")
                ? {
                    type: "href",
                    actionName: "编辑", // 默认actionName
                    // 根据grid数据 自定义显示actionName
                    handler: (res) => {
                      this.openTab(
                        { errorCodeInfo: res, levelOption: this.state.levelOption },
                        { key: "tMaterialsTypeConfig", titleText: "物料编辑" },
                      );
                    },
                  }
                : "",
              useAuth("901404")
                ? {
                    type: "confirm",
                    actionName: "禁用",
                    render: (record) => {
                      return record.status == 1 ? "禁用" : "启用";
                    },
                    handler: (record) => {
                      fetchHandler(updateMaterialsType, {
                        materialsId: record.key,
                        status: record.status == 1 ? 0 : 1,
                      }).then((res) => {
                        if (res && (res.code === "200" || res.code === "success")) {
                          message.success("操作成功");
                          RefreshGrid(this.context.store, "tMaterialsTypeManageTable");
                        }
                      });
                    },
                  }
                : "",
              useAuth("901405")
                ? {
                    type: "confirm",
                    actionName: "删除",
                    handler: (record) => {
                      console.log('recordrecordrecord', record)
                      fetchHandler(delMaterials, {
                        id: record.key,
                      }).then((res) => {
                        if (res && (res.code === "ok" || res.code === "success")) {
                          message.success("删除成功");
                          RefreshGrid(this.context.store, "tMaterialsTypeManageTable");
                        }
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: getMaterialsTypeList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入物料编码", // '请输入物料编码',
          param: {
            name: "materialsCode",
            type: "string",
          },
          labelName: "物料编码", // '故障名称:',
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入物料名称", // '请输入物料编码',
          param: {
            name: "materialsName",
            type: "string",
          },
          labelName: "物料名称", // '故障名称:',
          required: false,
        },
        {
          type: "select",
          options: this.state.useOption,
          placeholder: this.internationalization.title1, // '请选择:',
          param: {
            name: "useTypeId",
            type: "string",
          },
          labelName: "用途",
          required: !1,
        },
        {
          type: "select",
          options: [
            {
              text: "全部", // '全部',
              value: "",
            },
            {
              text: "禁用", // '禁用',
              value: "0",
            },
            {
              text: "启用", // '启用',
              value: "1",
            },
          ],
          placeholder: "请选择", // '请选择',
          param: {
            name: "status",
            type: "string",
          },
          labelName: "状态", // '状态',
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入品牌",
          param: {
            name: "brand",
            type: "string",
          },
          labelName: "品牌",
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "维修利用",
              value: "2",
            },
            {
              text: "其他",
              value: "0",
            },
          ],
          placeholder: "请选择",
          param: {
            name: "handingType",
            type: "string",
          },
          labelName: "处置方式",
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("901401")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.btn1, // '查询'
                }
              : "",
            useAuth("901402")
              ? {
                  btnType: "button",
                  text: "批量导入", // 导出
                  handler: (e, param) => {
                    this.setState({
                      seeStubBindLockVisible: true,
                    });

                    // this.exportData(param);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "tMaterialsTypeManageTable",
      tablePage: "故障上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "tMaterialsTypeManageTable", param);
    }
  };

  // 获取用途
  getTypeList() {
    fetchHandler(getMaterialsUseList, {}).then((res) => {
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: `${item.id}`,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.all, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          useOption: list,
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <Modal
          title="运维建议"
          visible={this.state.adviceVisible}
          footer={null}
          onCancel={() => this.setState({ adviceVisible: false })}>
          <div dangerouslySetInnerHTML={{ __html: this.state.adviceContent }}></div>
        </Modal>

        <Modal
          title="批量导入"
          visible={this.state.seeStubBindLockVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubBindLockVisible", false);
          }}>
          <GoodExcelIn
            onCancel={() => {
              this.setState({ seeStubBindLockVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "tMaterialsTypeManageTable");
            }}
          />
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(TMaterialsTypeManage);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/tMaterialsTypeManage/index.js